<div [hidden]="!CurrentScreenOption.IsVisible" class="CPQComponent">
  <label [htmlFor]="CurrentScreenOption.ID" [ngClass]="{'invalid' : !CurrentScreenOption.IsValid}">{{CurrentScreenOption.Caption + " " + CurrentScreenOption.Description}}</label>

  <select [id]="CurrentScreenOption.ID" [ngModel]="CurrentScreenOption.Value" [disabled]="!CurrentScreenOption.IsEnabled" [required]="CurrentScreenOption.IsRequired" (change)="selectOnChange($event,CurrentScreenOption.AutoContinueMode)">
    <option *ngFor="let opt of CurrentScreenOption.SelectableValues"
            selected="{{CurrentScreenOption.Value == opt.Value}}"
            [value]="opt.Value"
            key="opt.Value">
      {{opt.Caption}}
    </option>
  </select>
</div>
